import { makeAutoObservable, runInAction } from 'mobx';
import Cookies from 'js-cookie';
import { RootStore } from './RootStore';

export class ThemeStore {
  themeMode = Cookies.get('theme') || 'classic';

  constructor(private _: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setLigthTheme = () => {
    runInAction(() => {
      Cookies.set('theme', 'light');
    });
    this.themeMode = 'light';
  };

  setClassicTheme = () => {
    runInAction(() => {
      Cookies.set('theme', 'classic');
    });
    this.themeMode = 'classic';
  };

  setDarkTheme = () => {
    runInAction(() => {
      Cookies.set('theme', 'dark');
    });
    this.themeMode = 'dark';
  };
}
